import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.guid = this.el.getAttribute('data-guid');
        this.cards = this.el.querySelectorAll('.why_card');
        this.progressEls = this.el.querySelectorAll('.why_progress');
        this.rotate = -5;
        this.activeIndex = -1;
        this.cardRotations = new Array(this.cards.length).fill(0);

        this.onProgressWhy = (e) => {
            const { target, progress } = e.detail;

            if (this.guid != target.getAttribute('data-guid')) return;

            let activeEl = null;
            let activeIdx = -1;

            this.progressEls.forEach((el) => {
                if (!el.classList.contains('is-inview')) return;

                const idx = parseInt(el.getAttribute('data-index'), 10);
                if (idx >= activeIdx) {
                    activeIdx = idx;
                    activeEl = el;
                }
            });

            if (!activeEl || target !== activeEl) return;

            this.activeIndex = activeIdx;
            this.applyRotations(activeIdx, progress);
        };

        window.addEventListener('progressWhy', this.onProgressWhy);

        this.sameHeight();
        onWidthResize(() => {
            this.sameHeight();
        });
    }

    applyRotations(index, progress) {
        for (let i = 0; i < this.cards.length; i++) {
            let rotation = 0;

            if (i < index) {
                rotation = (index - 1 - i) * this.rotate + (this.rotate * progress);
            }

            this.cardRotations[i] = rotation;
            gsap.set(this.cards[i], { rotate: rotation });
        }
    }

    sameHeight() {
        const heights = [];

        for (let i = 0; i < this.cards.length; i++) {
            this.cards[i].style.height = 'auto';
            heights.push(this.cards[i].offsetHeight);
        }

        const tallest = Math.max(...heights);

        for (let i = 0; i < this.cards.length; i++) {
            gsap.set(this.cards[i], {
                height: tallest,
                rotate: this.cardRotations[i] || 0,
            });
        }

        setTimeout(() => {
            this.call('resize', 'Scroll');
        }, 100);
    }

    destroy() {
        window.removeEventListener('progressWhy', this.onProgressWhy);
    }
}
